import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingCTA() {
  return <Section className="bg-[#FAF8F5] py-20" data-id="element-98">
      <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#D4735E]/10 max-w-3xl mx-auto" data-id="element-99">
        <div className="p-8 md:p-12 text-center" data-id="element-100">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#2D2D2D] mb-6" data-id="element-101">
            Deja de elegir hombres que no te eligen.
          </h2>

          <p className="text-xl text-[#666666] mb-8" data-id="element-102">
            No necesitas más introspección.
            <br data-id="element-103" />
            <span className="font-bold text-[#D4735E]" data-id="element-104">
              Necesitas mejores decisiones.
            </span>
          </p>

          <div className="bg-[#FAF8F5] p-6 rounded-xl inline-block mb-8 w-full max-w-md" data-id="element-105">
            <div className="text-sm text-[#666666] uppercase tracking-wider mb-2" data-id="element-106">
              Precio único
            </div>
            <div className="text-5xl font-serif font-bold text-[#2D2D2D] mb-2" data-id="element-107">
              $14.99
            </div>
            <div className="text-sm text-[#D4735E] font-medium" data-id="element-108">
              Acceso inmediato (PDF)
            </div>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-109">
            <Button href="https://glowliftessencemx.com/checkouts/cn/hWN7pNUOqpeQk0A6TRAI7fAA/es-us?_r=AQABXEotWrlYvHcXS4HsY7ztujjlFOkA_CFfDQ7gJylr8qE&preview_theme_id=184489181460&skip_shop_pay=true" className="w-full md:w-auto px-12 py-4 text-xl shadow-xl shadow-[#D4735E]/30" data-id="element-110">
              Comprar ahora – $14.99
            </Button>

            <div className="flex flex-col md:flex-row items-center gap-4 mt-4 text-sm text-[#666666]" data-id="element-111">
              <span className="flex items-center gap-1.5" data-id="element-112">
                <ShieldCheck className="w-4 h-4 text-[#D4735E]" data-id="element-113" />
                Garantía de satisfacción
              </span>
              <span className="flex items-center gap-1.5" data-id="element-114">
                <Lock className="w-4 h-4 text-[#D4735E]" data-id="element-115" />
                Pago seguro y encriptado
              </span>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}